import React from "react";
import style from "./CulturePointer.module.css";

export function CulturePointer({icon, heading, content}) {
  return (
    <div className={style.culturePointer}>
        <img src={icon} alt="*" />
        <p className={style.text1}>{heading}</p>
        <p className={style.text2}>{content}</p>
    </div>
  );
}